export function bankTransferProgress(status, stages) {
    if (status !== 'pending')
        return status;
    return stages.some((stage) => stage.kind === 'waiting_payment' && stage.status === 'success')
        ? 'processing'
        : 'awaiting_transfer';
}
// MoonPay documents minutes to days, not a deterministic USDC delivery deadline.
// No countdown is derived from transaction creation or a client acknowledgement.
export const SEPA_ARRIVAL_ESTIMATE = 'minutes_to_days';
